$(document).ready(function(){

// move logo up 
	if($('.the-logo').length){	
		$( ".the-logo" ).insertAfter( $( ".header-bar" ) );
	}	

// search custom display in header
$("#top-src a").click(function(){
    $(".header-search.mpx-v3").toggle(300);
  });


// add category list classes 	
	if($('.righthead .site-nav').length){		
      $(".righthead .site-nav li").each(function(index) {
            $(this).addClass("trcat" + index);
      });
	}	
// add category list classes 	
	if($('#leftmenu').length){		
      $("#leftmenu li").each(function(index) {
            $(this).addClass("tlcat" + index);
      });
	}	
	
// add home elements classes 	
	if($('.template-index .shopify-section').length){		
      $(".template-index .shopify-section").each(function(index) {
            $(this).addClass("homebox" + index);
      });
	}	
	
// read more 
var hiddenInfo = $(".hidden-info");
    var readMoreTrigger = $(".read-more-trigger");
    
		//hide div .hidden-info
		hiddenInfo.hide();
    
	  readMoreTrigger.on("click", function(){
		//toggle the hidden div
	    hiddenInfo.toggle();
			//toggle text in .hidden-info to 'Read Less', 'Read More'
      if (readMoreTrigger.text() == ".")
        readMoreTrigger.text("");
				else readMoreTrigger.text("");
    });	
	
	
	
// add home clone elements classes 	
	if($('.template-page .page-seo-block').length){		
      $(".template-page").addClass("seo-page");
    }	
        



// move footer elements & add classes

	if($('#shopify-section-footer .grid-uniform.top-foot .grid__item').length){		
      $("#shopify-section-footer .grid-uniform.top-foot .grid__item").each(function(index) {       
        $(this).addClass("fbox" + index);
        // previous setting            $(this).removeClass( "post-large--one-half" ).addClass( "post-large--one-third" );
      });
	}
	

    if($('#shopify-section-footer .grid__item.fnews').length){	
		$( "#shopify-section-footer .grid__item.fnews" ).removeClass( "grid__item post-large--one-half post-large--one-third" ).appendTo( $( ".fbox3" ) );
	}	


// video home vimeo		
$('#hvideos .hvideo .hvideoimg').on('click', function() {
    $(this).addClass('hideit');
    $(this).next().addClass('active');
  });


// video cat vimeo		
$('#catvideos .catvideo .hvideoimg').on('click', function() {
    $(this).addClass('hideit');
    $(this).next().addClass('active');
  });


// video new product  vimeo		
$('.catvideo.prod-page .hvideoimg').on('click', function() {
    $(this).addClass('hideit');
    $(this).next().addClass('active');
  });





// video product vimeo		
$('#pvideo img , #pvideo .pvitext h3').on('click', function() {
    $('#pvholder').addClass('hideit');
    $('#vimeoid').addClass('active');
  });

// mobile menu overlay show hide

$('.the-hamburger').click(function(){
   $(this).next().addClass("show-mobile");
});

$('.closebtn').click(function(){
   $('#mobileNav').removeClass("show-mobile");
});

// mobile menu classes on click 
$('.no-link').click(function(){
    $(this).toggleClass("shows").next().toggleClass("show-cats");
    $(this).children("i").toggleClass("fa-flip-vertical");
});



// check Thickness  and add swacth active classes 	
if ($('body').hasClass('template-product')) {

if($('span#120g-active').length){		
    $(".thickness-switch.120g a").addClass("active-thickness");
}	
if($('span#175g-active').length){		
    $(".thickness-switch.175g a").addClass("active-thickness");
}	
if($('span#180g-active').length){		
    $(".thickness-switch.180g a").addClass("active-thickness");
}	
if($('span#140g-active').length){		
    $(".thickness-switch.140g a").addClass("active-thickness");
}	
if($('span#200g-active').length){		
    $(".thickness-switch.200g a").addClass("active-thickness");
}	
if($('span#220g-active').length){		
    $(".thickness-switch.220g a").addClass("active-thickness");
}	
if($('span#250g-active').length){		
    $(".thickness-switch.250g a").addClass("active-thickness");
}		
if($('span#160g-active').length){		
    $(".thickness-switch.160g a").addClass("active-thickness");
}	
if($('span#300g-active').length){		
    $(".thickness-switch.300g a").addClass("active-thickness");
}	





// check colour and add swacth active classes 	
if($('span#1-jet-black-active').length){		
    $(".1-jet-black a").addClass("active-image");
}	
if($('span#1b-natural-black-active').length){		
    $(".1b-natural-black a").addClass("active-image");
}	
if($('span#1c-mocha-brown-active').length){		
    $(".1c-mocha-brown a").addClass("active-image");
}	
if($('span#2-dark-brown-active').length){		
    $(".2-dark-brown a").addClass("active-image");
}	
if($('span#4-medium-brown-active').length){		
    $(".4-medium-brown a").addClass("active-image");
}	
if($('span#6-light-chestnut-brown-active').length){		
    $(".6-light-chestnut-brown a").addClass("active-image");
}	
if($('span#8-chestnut-brown-active').length){		
    $(".8-chestnut-brown a").addClass("active-image");
}	
if($('span#14-dark-blonde-active').length){		
    $(".14-dark-blonde a").addClass("active-image");
}	
if($('span#18-golden-blonde-active').length){		
    $(".18-golden-blonde a").addClass("active-image");
}	
if($('span#8-613-brown-blonde-mix-active').length){		
    $(".8-613-brown-blonde-mix a").addClass("active-image");
}	
if($('span#16-light-golden-blonde-active').length){		
    $(".16-light-golden-blonde a").addClass("active-image");
}	
if($('span#27-strawberry-blonde-active').length){		
    $(".27-strawberry-blonde a").addClass("active-image");
}	
if($('span#27-613-blonde-mix-active').length){		
    $(".27-613-blonde-mix a").addClass("active-image");
}	
if($('span#60-light-blonde-active').length){		
    $(".60-light-blonde a").addClass("active-image");
}	
if($('span#60a-light-ash-blonde-active').length){		
    $(".60a-light-ash-blonde a").addClass("active-image");
}
if($('span#ice-blonde-active').length){		
    $(".ice-blonde a").addClass("active-image");
}	
if($('span#silver-active').length){		
    $(".silver a").addClass("active-image");
}	
if($('span#33-dark-auburn-active').length){		
    $(".33-dark-auburn a").addClass("active-image");
}		
if($('span#60w-platinum-blonde-active').length){		
    $(".60w-platinum-blonde a").addClass("active-image");
}		
if($('span#platinum-blonde-active').length){		
    $(".platinum-blonde a").addClass("active-image");
}			
if($('span#light-grey-active').length){		
    $(".light-grey a").addClass("active-image");
}		
if($('span#light-silver-active').length){		
    $(".light-silver a").addClass("active-image");
}	
if($('span#dark-silver-active').length){		
    $(".dark-silver a").addClass("active-image");
}			
if($('span#dark-grey-active').length){		
    $(".dark-grey a").addClass("active-image");
}		
if($('span#p16-60-highlights-active').length){		
    $(".p16-60-highlights a").addClass("active-image");
}	
if($('span#p14-24k-highlights-active').length){		
    $(".p14-24k-highlights a").addClass("active-image");
}
if($('span#12-613-brown-blonde-mix-active').length){		
    $(".12-613-brown-blonde-mix a").addClass("active-image");
}
if($('span#613-bleached-blonde-active').length){		
    $(".613-bleached-blonde a").addClass("active-image");
}
if($('span#p18k-613-highlights-active').length){		
    $(".p18k-613-highlights a").addClass("active-image");
}
if($('span#t8-60-t8-14-balayage-active').length){		
    $(".t8-60-t8-14-balayage a").addClass("active-image");
}
if($('span#t-8-24-60-balayage-active').length){		
    $(".t-8-24-60-balayage a").addClass("active-image");
}
if($('span#t2-27-t2-60-ombre-active').length){		
    $(".t2-27-t2-60-ombre a").addClass("active-image");
}
if($('span#t18-60-t18-60-balayage-active').length){		
    $(".t18-60-t18-60-balayage a").addClass("active-image");
}
if($('span#t4-27-t8-24a-ombre-active').length){		
    $(".t4-27-t8-24a-ombre a").addClass("active-image");
}
if($('span#r19-613-ombre-active').length){		
    $(".r19-613-ombre a").addClass("active-image");
}
if($('span#t-grey-18-60-ombre-active').length){		
    $(".t-grey-18-60-ombre a").addClass("active-image");
}
if($('span#t-02-02-08-balayage-active').length){		
    $(".t-02-02-08-balayage a").addClass("active-image");
}
if($('span#t-02-04-ombre-active').length){		
    $(".t-02-04-ombre a").addClass("active-image");
}
if($('span#t-02-06-ombre-active').length){		
    $(".t-02-06-ombre a").addClass("active-image");
}
if($('span#t-08-08-60-balayage-active').length){		
    $(".t-08-08-60-balayage a").addClass("active-image");
}
if($('span#t-04-08-ombre-active').length){		
    $(".t-04-08-ombre a").addClass("active-image");
}
if($('span#t-04-18-ombre-active').length){		
    $(".t-04-18-ombre a").addClass("active-image");
}
if($('span#t-16-60-ombre-active').length){
    $(".t-16-60-ombre a").addClass("active-image");
} 
if($('span#t-1c-16-ombre-active').length){		
    $(".t-1c-16-ombre a").addClass("active-image");
}
if($('span#t-1c-1c-04-balayage-active').length){		
    $(".t-1c-1c-04-balayage a").addClass("active-image");
}
if($('span#18k-golden-blonde-active').length){		
    $(".18k-golden-blonde a").addClass("active-image");
}	
if($('span#p18-60-highlights-active').length){		
    $(".p18-60-highlights a").addClass("active-image");
}	
if($('span#t4-27-t8-24-ombre-active').length){		
    $(".t4-27-t8-24-ombre a").addClass("active-image");
}
if($('span#t8-24-p60-balayage-active').length){		
    $(".t8-24-p60-balayage a").addClass("active-image");
}
if($('span#t-grey-18-60-ombre-active').length){		
    $(".t-grey-18-60-ombre a").addClass("active-image");
}
if($('span#hot-pink-active').length){		
    $(".hot-pink a").addClass("active-image");
}
if($('span#red-active').length){		
    $(".red a").addClass("active-image");
}
if($('span#blue-active').length){		
    $(".blue a").addClass("active-image");
}
if($('span#burgundy-active').length){		
    $(".burgundy a").addClass("active-image");
}
if($('span#t8a-60pt8a-60-balayage-active').length){		
    $(".t8a-60pt8a-60-balayage a").addClass("active-image");
}
if($('span#f4a-4a8a613-balayage-active').length){		
    $(".f4a-4a8a613-balayage a").addClass("active-image");
}


} // end template-product-only swatch logic


		
		

// custom categories add class 
	
if($('#categories-swatch').length){		
    $(".wrapper.main-content").addClass("custom-categories-swatches");
}	

// custom quantity input
$('.qtybox .btnqty').on('click', function(){
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
  }); 
  
	

// reviews add title 
if($('.template-product .yotpo-main-widget').length){	
$( "<h2 class='reviews-title'>CUSTOMER REVIEWS</h2>" ).insertBefore( ".template-product .yotpo-main-widget" );
}


// get the browser size for product image carousel 
var getBrowserWidth = function(){
    if(window.innerWidth < 680){
        // The Small Device
        return "small-screen";
    } else {
        // Large Device
        return "large-screen"
    }
};
var device = getBrowserWidth();


if(device === "small-screen"){
    // Enter your script for handheld devices here 
    $(".template-product #ProductPhoto").addClass("gallmobile");
    $(".template-product .product-single .one-eighth").addClass("hideit");
    $( '#ProductPhoto' ).addClass( "owl-carousel" );
    $( '#ProductPhoto .product-single__image-wrapper' ).addClass("showthumb");
  }

$('#ProductPhoto.owl-carousel').owlCarousel({
    loop:true,
    margin:15,
   responsiveClass:true,
	rewind: true,
    nav:true,
	navText : ["&lsaquo;","&rsaquo;"],
	dots : true,
    responsive:{
        0:{
            items:1,
        },
        600:{
            items:1,
        },
        800:{
            items:1,
        },
        1000:{
            items:1,
        },
		1200:{
            items:1,
        }
    }
})



 // carousel homepage 		

$('.home-reviews.owl-carousel').owlCarousel({
    loop:true,
    stagePadding:50,
    margin:50,
    responsiveClass:true,
	rewind: true,
    dots:false,
    nav:true,
	navText : ["&lsaquo;","&rsaquo;"],
    responsive:{
        0:{
            items:1,
			slideBy: 1 ,
            stagePadding:0,
            margin:5
        },
        600:{
            items:1,
			slideBy: 1,
            stagePadding:0,
            margin:10
        },
        800:{
            items:1,
			slideBy: 1,
            stagePadding:0,
            margin:15
        },
        1000:{
            items:1,
			slideBy: 1,
            stagePadding:0
        },
		1200:{
            items:2,
			slideBy: 2 
        }
    }
})	


//count image thumbs to remove carousel if  needed
// manualy remove owl-carousel class from the product template thumbs
//var licount = $("#ProductThumbs").children().length;
//if (licount > 4){
//    $( '#ProductThumbs' ).addClass( "owl-carousel" );
//}	  
	
// carousel thumbs
						  
//$('#ProductThumbs.owl-carousel').owlCarousel({
//    loop:true,
//    margin:15,
//   responsiveClass:true,
//	rewind: true,
//    nav:true,
//	navText : ["&lsaquo;","&rsaquo;"],
//    responsive:{
//        0:{
//            items:4,
//        },
//        600:{
//            items:4,
//        },
//        800:{
//            items:4,
//        },
//        1000:{
//            items:4,
//        },
//		1200:{
//            items:4,
//        }
//    }
//})	
	
	
});



$(window).load(function() { 

    // add recentlry viewed classes 	
        if($('#recently-viewed-products').length){		
            $("#recently-viewed-products .product").each(function(index) {
                  $(this).addClass("prod" + index);
            });
          }	
        
    });